/* Spanish cart drawer. snippets/pdp-cart-drawer.liquid decides early whether
   this visitor is a Spanish viewer (html.mm-es); this file swaps every piece
   of drawer text — Liquid defaults, editor settings and the strings
   pdp-trimmer.js paints later — through one dictionary, and swaps it back if
   the 15-in-1 EN|ES toggle flips to English. New English copy in the drawer
   needs an entry in D (exact text) or P (patterns). */
(function () {
  'use strict';

  var D = {
    'Your Cart': 'Tu carrito',
    'Cart': 'Carrito',
    'Free shipping': 'Envío gratis',
    'Free Shipping': 'Envío gratis',
    'Free US shipping': 'Envío gratis en EE. UU.',
    'Your cart is empty': 'Tu carrito está vacío',
    'Shop Best Sellers': 'Ver los más vendidos',
    'Most popular': 'Más popular',
    'Add to cart': 'Añadir al carrito',
    'See full details': 'Ver detalles',
    'Most add this': 'La mayoría añade esto',
    'Your cart is reserved for': 'Tu carrito está reservado por',
    'Your cart hold has ended': 'La reserva de tu carrito terminó',
    'You unlocked free shipping!': '¡Desbloqueaste el envío gratis!',
    'You unlocked': 'Desbloqueaste',
    '🎉 You unlocked': '🎉 Desbloqueaste',
    'free shipping': 'el envío gratis',
    'You’re': 'Te faltan',
    "You're": 'Te faltan',
    'away from free shipping': 'para el envío gratis',
    'Delivered by': 'Entrega estimada',
    'Delivered every': 'Entrega cada',
    'Cancel anytime': 'Cancela cuando quieras',
    /* Purchase-type pill — same Spanish as the PDP offer cards (pdp-mm15-es.js). */
    'Subscribe & Save': 'Únete al plan y ahorra',
    'One-time purchase': 'Compra única',
    'One time purchase': 'Compra única',
    'One-Time': 'Compra única',
    'Purchase type': 'Tipo de compra',
    'Discounts': 'Descuentos',
    'Total': 'Total',
    'Total pending': 'Total pendiente',
    'Secure checkout': 'Pago seguro',
    'SECURE CHECKOUT': 'PAGO SEGURO',
    'Checkout': 'Pagar',
    'By proceeding to Checkout, you agree to our': 'Al continuar al pago, aceptas nuestros',
    'Terms of Service': 'Términos del servicio',
    'Refund Policy': 'Política de reembolso',
    'Privacy Policy': 'Política de privacidad',
    ', and': ' y',
    'Free gift': 'Regalo gratis',
    'Your free gift': 'Tu regalo gratis',
    'Add free gift': 'Añadir regalo gratis',
    'You unlocked your free gift': 'Desbloqueaste tu regalo gratis',
    'Included with this bundle': 'Incluido con este paquete',
    'Free': 'Gratis',
    'Have a promo code?': '¿Tienes un código promocional?',
    'Apply': 'Aplicar',
    'Remove': 'Eliminar',
    'Save': 'Ahorra',
    'Buy': 'Comprar',
    'Item': 'Artículo',
    'Bundle & save': 'Paquete y ahorro',
    'Processing…': 'Procesando…',
    'Adding…': 'Añadiendo…',
    '✓ Added': '✓ Añadido',
    '✓ Joined': '✓ Listo',
    'Error': 'Error',
    'Error — try again': 'Error — inténtalo de nuevo',
    'Couldn’t add — try again': 'No se pudo añadir — inténtalo de nuevo',
    'Couldn’t add that item — please try again.': 'No pudimos añadir el producto — inténtalo de nuevo.',
    'Code saved — applied at checkout.': 'Código guardado — se aplicará al pagar.',
    'Could not apply code. Please try again.': 'No se pudo aplicar el código. Inténtalo de nuevo.',
    'Could not start checkout. Please try again.': 'No se pudo iniciar el pago. Inténtalo de nuevo.',
    'Could not add item to cart. Please try again.': 'No se pudo añadir al carrito. Inténtalo de nuevo.',
    "Couldn't reach the store — check your connection and tap Add to cart again.": 'No pudimos conectar con la tienda. Revisa tu conexión y toca Añadir al carrito de nuevo.',    'A network error occurred. Please check your connection and try again.': 'Ocurrió un error de red. Revisa tu conexión e inténtalo de nuevo.',
    'Please select a variant before adding to cart.': 'Selecciona una variante antes de añadir al carrito.',
    'Close cart': 'Cerrar carrito',
    'Quantity': 'Cantidad',
    'Remove one': 'Quitar uno',
    'Add one': 'Añadir uno',
    'Cart banner': 'Banner del carrito',
    'Cart promotional banner': 'Banner promocional del carrito',
    'T+ Advanced': 'T+ Avanzado',
    'Eliminate Eye Bags + Puffiness': 'Elimina bolsas e hinchazón de ojos',
    'If it cuts you, we buy it back — 30 days': 'Si te corta, te lo recompramos — 30 días',
    /* Trust badges under the checkout button (editor text, cart_trust_1..3). */
    'T-Levels increased': 'T-Levels en aumento',
    'T-Levels Increased': 'T-Levels en aumento',
    'T-Levels skyrocket': 'T-Levels por las nubes',
    'Free US Shipping': 'Envío gratis en EE. UU.',
    'Money-back guarantee': 'Garantía de devolución',
    'Money back guarantee': 'Garantía de devolución',
    'Guarantee': 'Garantía',
    'Secure Checkout': 'Pago seguro',
    'Secure payment': 'Pago seguro',
    'Secure Payment': 'Pago seguro',
    'day': 'día', 'week': 'semana', 'month': 'mes', 'year': 'año'
  };

  var DAYS = { Mon: 'lun', Tue: 'mar', Wed: 'mié', Thu: 'jue', Fri: 'vie', Sat: 'sáb', Sun: 'dom' };
  var MONTHS = { Jan: 'ene', Feb: 'feb', Mar: 'mar', Apr: 'abr', May: 'may', Jun: 'jun', Jul: 'jul', Aug: 'ago', Sep: 'sep', Oct: 'oct', Nov: 'nov', Dec: 'dic' };
  var UNITS = { days: 'días', weeks: 'semanas', months: 'meses', years: 'años' };

  var P = [
    [/^Rated ([\d.]+)\/5 by ([\d,.]+)\+? men$/, function (m) { return 'Calificado ' + m[1] + '/5 por más de ' + m[2] + ' hombres'; }],
    [/^Save (\S*\d\S*)$/, function (m) { return 'Ahorra ' + m[1]; }],
    [/^(\S*\d\S*)\/day$/, function (m) { return m[1] + '/día'; }],
    [/^(\S*\d\S*) total$/, function (m) { return m[1] + ' en total'; }],
    [/^(\d+) (days|weeks|months|years)$/, function (m) { return m[1] + ' ' + UNITS[m[2]]; }],
    [/^(\d+)-Day Supply$/i, function (m) { return 'Suministro de ' + m[1] + ' días'; }],
    [/^Deliver every (\d+) (days|weeks|months|years)$/i, function (m) { return 'Entrega cada ' + m[1] + ' ' + UNITS[m[2].toLowerCase()]; }],
    [/^(\d+)[- ]Day (?:Money[- ]Back )?Guarantee$/i, function (m) { return 'Garantía de ' + m[1] + ' días'; }],
    [/^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{1,2})$/, function (m) { return DAYS[m[1]] + ', ' + m[3] + ' ' + MONTHS[m[2]]; }],
    [/^Remove (.+)$/, function (m) { return 'Eliminar ' + (D[m[1]] || m[1]); }],
    [/^You[’']re (\S+) away from free shipping$/, function (m) { return 'Te faltan ' + m[1] + ' para el envío gratis'; }],
    [/^Add (\S+) more to unlock your free gift$/, function (m) { return 'Añade ' + m[1] + ' más para desbloquear tu regalo gratis'; }],
    [/^Add (\S+) to unlock your (.+)$/, function (m) { return 'Añade ' + m[1] + ' para desbloquear tu ' + (D[m[2]] || m[2]); }],
    [/^🎁 You unlocked your (.+)!$/, function (m) { return '🎁 ¡Desbloqueaste tu ' + (D[m[1]] || m[1]) + '!'; }]
  ];

  function translated(src) {
    var key = src.trim(), t = key ? es(key) : null;
    return t == null ? src : src.replace(key, t);
  }

  function es(s) {
    if (Object.prototype.hasOwnProperty.call(D, s)) return D[s];
    for (var i = 0; i < P.length; i++) {
      var m = P[i][0].exec(s);
      if (m) return P[i][1](m);
    }
    return null;
  }

  var ATTRS = ['aria-label', 'placeholder', 'title', 'alt'];
  var origText = new WeakMap();   // text node -> English source
  var origAttr = new WeakMap();   // element -> { attr: English source }
  var painting = false;

  function isOn() { return document.documentElement.classList.contains('mm-es'); }

  function doText(n, on) {
    var p = n.parentNode;
    if (!p || p.nodeName === 'SCRIPT' || p.nodeName === 'STYLE') return;
    var cur = n.nodeValue;
    var src = origText.get(n);
    // JS repainted the node since we last touched it: the new value is the source.
    if (src === undefined || (cur !== src && cur !== translated(src))) {
      src = cur; origText.set(n, src);
    }
    var key = src.trim();
    if (!key) return;
    var t = on ? es(key) : null;
    var want = t == null ? src : src.replace(key, t);
    if (cur !== want) n.nodeValue = want;
  }

  function doAttrs(el, on) {
    var store = origAttr.get(el);
    for (var i = 0; i < ATTRS.length; i++) {
      var a = ATTRS[i], cur = el.getAttribute(a);
      if (cur == null) continue;
      if (!store) { store = {}; origAttr.set(el, store); }
      var src = store[a];
      if (src === undefined || (cur !== src && cur !== es(src))) { src = cur; store[a] = src; }
      var t = on ? es(src.trim()) : null;
      var want = t == null ? src : t;
      if (cur !== want) el.setAttribute(a, want);
    }
  }

  function paint(root) {
    if (!root) return;
    var on = isOn();
    painting = true;
    try {
      if (root.nodeType === 3) { doText(root, on); return; }
      if (root.nodeType !== 1) return;
      doAttrs(root, on);
      var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT);
      var n;
      while ((n = w.nextNode())) {
        if (n.nodeType === 3) doText(n, on); else doAttrs(n, on);
      }
    } finally { painting = false; }
  }

  function start() {
    var drawer = document.getElementById('mm-cart');
    if (!drawer) return;
    paint(drawer);
    new MutationObserver(function (list) {
      if (painting) return;
      for (var i = 0; i < list.length; i++) {
        var r = list[i];
        if (r.type === 'childList') r.addedNodes.forEach(paint);
        else paint(r.target);
      }
    }).observe(drawer, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ATTRS });
    // Follow the html.mm-es class (the 15-in-1 EN|ES toggle flips it).
    new MutationObserver(function () { paint(drawer); })
      .observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  }

  window.mmCartEs = { t: es, paint: function () { paint(document.getElementById('mm-cart')); } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
